<template>
  <svg :width="width"
       :height="height"
       role="presentation"
       viewBox="0 0 16 16"
       @click="$emit('click')">
    <path d="M11.744 8.439c-.018-1.773 1.48-2.624 1.547-2.666-.842-1.203-2.153-1.368-2.62-1.387-1.116-.11-2.177.642-2.743.642-.565 0-1.44-.626-2.364-.61-1.217.018-2.338.692-2.964 1.756-1.264 2.142-.324 5.316.908 7.054.602.85 1.32 1.805 2.261 1.771.908-.035 1.25-.574 2.348-.574 1.096 0 1.405.574 2.365.557.976-.018 1.595-.867 2.192-1.72.691-.987.976-1.942.993-1.991-.022-.01-1.904-.715-1.923-2.832zM9.94 3.236c.5-.593.838-1.416.745-2.236-.72.029-1.593.469-2.11 1.06-.463.525-.87 1.362-.76 2.166.804.062 1.624-.399 2.125-.99z" :fill="disabled ? disabledStateColor : iconColor" fill-rule="nonzero"/>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>